import { Injectable, inject } from '@angular/core';

import { Analytics } from '@core/analytics-types';

export enum SampleDataRemoveContext {
  Jobs = 'Jobs',
  TalentPools = 'Talent Pools',
  Candidates = 'Candidates',
  TrialCenter = 'Trial Center',
}

export enum ChooseYourPlanContext {
  TrialCenter = 'Trial Center',
  Topbar = 'Topbar',
  Billing = 'Billing',
  RecruiteeAcademy = 'Recruitee Academy',
  OfferPromote = 'Offer Promote',
  JobSlotsLimitModal = 'JobSlotsLimitModal',
}

@Injectable({ providedIn: 'root' })
export class SampleDataAnalyticsService {
  private readonly analytics = inject(Analytics);

  private readonly EVENT = {
    OpenTrialCenter: '[Trial] OpenTrialCenter',
    ChatWithUs: '[Trial] ChatWithUs',
    OpenRecruiteeAcademy: '[Trial] OpenRecruiteeAcademy',
    LearnMore: '[Trial] LearnMore',
    RemoveSampleData: '[Trial] RemoveSampleData',
    FillAccountWithSampleData: '[Trial] FillAccountWithSampleData',
    ChooseYourPlan: '[Trial] ChooseYourPlan',
    GetStarted: '[Onboarding] GetStarted',
  };

  public trackOpenTrialCenter(): void {
    this.analytics.track(this.EVENT.OpenTrialCenter);
  }

  public trackChatWithUs(): void {
    this.analytics.track(this.EVENT.ChatWithUs);
  }

  public trackOpenRecruiteeAcademy(): void {
    this.analytics.track(this.EVENT.OpenRecruiteeAcademy);
  }

  public trackLearnMore(): void {
    this.analytics.track(this.EVENT.LearnMore);
  }

  public trackRemoveSampleData(viewContext: SampleDataRemoveContext): void {
    this.analytics.track(this.EVENT.RemoveSampleData, { viewContext });
  }

  public trackFillAccountWithSampleData(): void {
    this.analytics.track(this.EVENT.FillAccountWithSampleData);
  }

  public trackChooseYourPlan(
    viewContext: ChooseYourPlanContext,
    isSampleData: boolean,
    trialDaysLeft: number,
  ): void {
    this.analytics.track(this.EVENT.ChooseYourPlan, { viewContext, isSampleData, trialDaysLeft });
  }

  public trackGetStarted(): void {
    this.analytics.track(this.EVENT.GetStarted);
  }
}
